__turbopack_context__.v({
  "imageStyles": "ImageNodeView-module-module__aueAZW__imageStyles",
});
